import gql from 'graphql-tag';

export const GET_SORTED_MISSIONS = gql`
  query GetSortedMissions($projectNumber: String!, $orderBy: OrderByInput) {
    missions(orderBy: $orderBy, where: { project: { projectNumber: $projectNumber } }) {
      id
    }
  }
`;
